import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.18532 1.86656C9.51291 3.19415 9.75119 5.20256 8.90017 6.80247L14.0612 11.9635C14.2565 12.1588 14.2565 12.4754 14.0612 12.6706L13.1344 13.5975C12.9391 13.7927 12.6225 13.7927 12.4273 13.5975L11.9979 13.1681L9.98659 15.1794L8.91001 14.1028L10.9213 12.0915L9.82702 10.9972L8.16929 12.655L7.11402 11.5997L8.77176 9.94197L7.26622 8.43643C5.6663 9.28745 3.6579 9.04916 2.33031 7.72157C0.730392 6.12166 0.730392 3.46648 2.33031 1.86656C3.96426 0.232605 6.5854 0.266646 8.18532 1.86656ZM6.72156 3.33031C7.53854 4.14729 7.53854 5.44084 6.72157 6.25782C5.90459 7.0748 4.61104 7.0748 3.79406 6.25782C2.97708 5.44084 2.97708 4.14729 3.79406 3.33031C4.61104 2.51334 5.90459 2.51334 6.72156 3.33031Z"
      fill="#5D5AB5"
    />
  </svg>
);

const KeyIcon = (props) => <Icon component={svg} {...props} />;

export default KeyIcon;
